// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormVendor } from '~/utils/interface/vendors';

export const schema = (t: TFunction) => {
  return yup.object({});
};

export const defaultValuesFormVendor: IFormVendor = {
  vendorName: EMPTY_STRING,
  address: EMPTY_STRING,
  city: EMPTY_STRING,
  contactName: EMPTY_STRING,
  description: EMPTY_STRING,
  email: EMPTY_STRING,
  phoneNumber: EMPTY_STRING,
  postalCode: EMPTY_STRING,
  state: EMPTY_STRING,
  type: EMPTY_STRING,
  website: EMPTY_STRING,
};
